import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import './FallenItem.scss';

class Fallen extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        const CustomFallenStyle = {
            backgroundImage: `url(./static/images/fallen/${this.props.item.Image}.png?v=3)`
        }
        return (
            <div className="item">
                <Link to={`article/${this.props.item.ArticleID}`}>
                    <div className="poster">
                        <div className="padding">
                            <div className="image" style={CustomFallenStyle}>
                                <div className="readmore">{this.props.item.ImageCredit || "לסיפור המלא"}</div>
                            </div>
                        </div>
                    </div>
                    <div className="bio">
                        <div className="name">{this.props.item.FullName}</div>
                        <div className="year">{this.props.item.YearFallen}</div>
                    </div>
                </Link>
            </div>
        );
    }
}
export default Fallen;



// WEBPACK FOOTER //
// ./src/Components/Fallen/FallenItem.jsx